module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saved-words"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("savedWords.savedWords.loading")) + "\n    "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('div', [_c('p', {
    staticStyle: {
      "margin": "40px",
      "text-align": "center"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("savedWords.savedWords.register-only")) + "\n    ")]), _vm._v(" "), _c('LoginButton')], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "wordsExp"
  }, [(_vm.savedWords) ? _c('v-expansion-panel', {
    attrs: {
      "focusable": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [(_vm.user) ? _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "expHeader"
        }, [_vm._v("\n            " + _vm._s(_vm.$t("savedWords.savedWords.saved")) + "(" + _vm._s(_vm.savedWords.length) + ")\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "expIcon"
        }, [_c('inline-svg', {
          staticClass: "saveSvg saveWord savedWord",
          attrs: {
            "src": require('../../assets/svg/saved.svg').default
          }
        })], 1)]
      },
      proxy: true
    }], null, false, 1656525167)
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expContent"
  }, [(_vm.user) ? _c('div', _vm._l((_vm.savedWords), function(word, idx) {
    return _c('div', {
      key: word.objectID,
      staticClass: "word"
    }, [_c('button', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          return _vm.removeWord(word)
        }
      }
    }, [_c('inline-svg', {
      staticClass: "saveSvg saveWord",
      class: {
        savedWord: _vm.isSaved(word)
      },
      attrs: {
        "src": _vm.isSaved(word) ?
          require('../../assets/svg/saved.svg').default :
          require('../../assets/svg/notsaved.svg').default
      }
    }), _vm._v("\n                  " + _vm._s(_vm.$t("savedWords.savedWords.remove")) + "\n                ")], 1), _vm._v(" "), _c('div', {
      ref: "translations",
      refInFor: true,
      staticClass: "translations"
    }, [_c('span', {
      staticClass: "arbT"
    }, [_vm._v(_vm._s(word.Eng))]), _vm._v(" "), _c('span', {
      staticClass: "heb",
      style: ({
        direction: _vm.destLlr ? 'ltr' : 'rtl'
      })
    }, [_vm._v(_vm._s(word.heb))])]), _vm._v(" "), _c('div', {
      staticClass: "word-left"
    }, [(!word.know) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup0.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 1) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup1.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 2) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup2.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 3) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup3.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 4) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup4.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know >= 5) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/progress-100.svg').default
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "audio"
    }, [_c('AudioBtn', {
      attrs: {
        "urlId": word.id
      }
    })], 1)])
  }), 0) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "expHeader"
        }, [_vm._v("\n            " + _vm._s(_vm.$t("savedWords.savedWords.memorization")) + "(" + _vm._s(_vm.processWords.length) + ")\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "expIcon"
        }, [_c('inline-svg', {
          staticClass: "progress-icon",
          attrs: {
            "src": require('../../assets/svg/Cup2.svg').default
          }
        })], 1)]
      },
      proxy: true
    }], null, false, 2425121823)
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expContent"
  }, [(_vm.user) ? _c('div', _vm._l((_vm.processWords), function(word, idx) {
    return _c('div', {
      key: word.objectID,
      staticClass: "word"
    }, [(_vm.isSaved(word)) ? _c('button', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          return _vm.removeWord(word)
        }
      }
    }, [_c('inline-svg', {
      staticClass: "saveSvg saveWord savedWord",
      attrs: {
        "src": require('../../assets/svg/saved.svg').default
      }
    }), _vm._v("\n                  " + _vm._s(_vm.$t("savedWords.savedWords.remove")) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (!_vm.isSaved(word)) ? _c('button', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          return _vm.addWord(word)
        }
      }
    }, [_c('inline-svg', {
      staticClass: "saveSvg saveWord",
      attrs: {
        "src": require('../../assets/svg/notsaved.svg').default
      }
    }), _vm._v("\n                  " + _vm._s(_vm.$t("savedWords.savedWords.save")) + "\n                ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "translations",
      refInFor: true,
      staticClass: "translations"
    }, [_c('span', {
      staticClass: "arbT"
    }, [_vm._v(_vm._s(word.Eng))]), _vm._v(" "), _c('span', {
      staticClass: "heb",
      style: ({
        direction: _vm.destLlr ? 'ltr' : 'rtl'
      })
    }, [_vm._v(_vm._s(word.heb))])]), _vm._v(" "), _c('div', {
      staticClass: "word-left"
    }, [(!word.know) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup0.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 1) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup1.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 2) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup2.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 3) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup3.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 4) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup4.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know >= 5) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/progress-100.svg').default
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "audio"
    }, [_c('AudioBtn', {
      attrs: {
        "urlId": word.id
      }
    })], 1)])
  }), 0) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "expHeader"
        }, [_vm._v("\n            " + _vm._s(_vm.$t("savedWords.savedWords.memorization2")) + "(" + _vm._s(_vm.fullWords.length) + ")\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "expIcon"
        }, [_c('inline-svg', {
          staticClass: "progress-icon",
          attrs: {
            "src": require('../../assets/svg/Cup4.svg').default
          }
        })], 1)]
      },
      proxy: true
    }], null, false, 1205036051)
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expContent"
  }, [(_vm.user) ? _c('div', _vm._l((_vm.fullWords), function(word, idx) {
    return _c('div', {
      key: word.objectID,
      staticClass: "word"
    }, [(_vm.isSaved(word)) ? _c('button', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          return _vm.removeWord(word)
        }
      }
    }, [_c('inline-svg', {
      staticClass: "saveSvg saveWord savedWord",
      attrs: {
        "src": require('../../assets/svg/saved.svg').default
      }
    }), _vm._v("\n                  " + _vm._s(_vm.$t("savedWords.savedWords.remove")) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (!_vm.isSaved(word)) ? _c('button', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          return _vm.addWord(word)
        }
      }
    }, [_c('inline-svg', {
      staticClass: "saveSvg saveWord",
      attrs: {
        "src": require('../../assets/svg/notsaved.svg').default
      }
    }), _vm._v("\n                  " + _vm._s(_vm.$t("savedWords.savedWords.save")) + "\n                ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "translations",
      refInFor: true,
      staticClass: "translations"
    }, [_c('span', {
      staticClass: "arbT"
    }, [_vm._v(_vm._s(word.Eng))]), _vm._v(" "), _c('span', {
      staticClass: "heb",
      style: ({
        direction: _vm.destLlr ? 'ltr' : 'rtl'
      })
    }, [_vm._v(_vm._s(word.heb))])]), _vm._v(" "), _c('div', {
      staticClass: "word-left"
    }, [(!word.know) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup0.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 1) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup1.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 2) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup2.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 3) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup3.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know == 4) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/Cup4.svg').default
      }
    }) : _vm._e(), _vm._v(" "), (word.know >= 5) ? _c('inline-svg', {
      staticClass: "progress-icon",
      attrs: {
        "src": require('../../assets/svg/progress-100.svg').default
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "audio"
    }, [_c('AudioBtn', {
      attrs: {
        "urlId": word.id
      }
    })], 1)])
  }), 0) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('v-expansion-panel-content', {
      key: group.name,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('div', {
            staticClass: "expHeader"
          }, [_vm._v(_vm._s(group.name))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
      staticClass: "expContent"
    }, [_c('div', _vm._l((group.words), function(word, idx) {
      return _c('div', {
        key: word.objectID,
        staticClass: "word"
      }, [(_vm.isSaved(word)) ? _c('button', {
        staticClass: "btn-remove",
        on: {
          "click": function($event) {
            return _vm.removeWord(word)
          }
        }
      }, [_c('inline-svg', {
        staticClass: "saveSvg saveWord savedWord",
        attrs: {
          "src": require('../../assets/svg/saved.svg').default
        }
      }), _vm._v("\n                  " + _vm._s(_vm.$t("savedWords.savedWords.remove")) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (!_vm.isSaved(word)) ? _c('button', {
        staticClass: "btn-remove",
        on: {
          "click": function($event) {
            return _vm.addWord(word)
          }
        }
      }, [_c('inline-svg', {
        staticClass: "saveSvg saveWord",
        attrs: {
          "src": require('../../assets/svg/notsaved.svg').default
        }
      }), _vm._v("\n                  " + _vm._s(_vm.$t("savedWords.savedWords.save")) + "\n                ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
        ref: "translations",
        refInFor: true,
        staticClass: "translations"
      }, [_c('span', {
        staticClass: "arbT"
      }, [_vm._v(_vm._s(word.Eng))]), _vm._v(" "), _c('span', {
        staticClass: "heb",
        style: ({
          direction: _vm.destLlr ? 'ltr' : 'rtl'
        })
      }, [_vm._v(_vm._s(word.heb) + " ")])]), _vm._v(" "), _c('div', {
        staticClass: "word-left"
      }, [(!word.know) ? _c('inline-svg', {
        staticClass: "progress-icon",
        attrs: {
          "src": require('../../assets/svg/Cup0.svg').default
        }
      }) : _vm._e(), _vm._v(" "), (word.know == 1) ? _c('inline-svg', {
        staticClass: "progress-icon",
        attrs: {
          "src": require('../../assets/svg/Cup1.svg').default
        }
      }) : _vm._e(), _vm._v(" "), (word.know == 2) ? _c('inline-svg', {
        staticClass: "progress-icon",
        attrs: {
          "src": require('../../assets/svg/Cup2.svg').default
        }
      }) : _vm._e(), _vm._v(" "), (word.know == 3) ? _c('inline-svg', {
        staticClass: "progress-icon",
        attrs: {
          "src": require('../../assets/svg/Cup3.svg').default
        }
      }) : _vm._e(), _vm._v(" "), (word.know == 4) ? _c('inline-svg', {
        staticClass: "progress-icon",
        attrs: {
          "src": require('../../assets/svg/Cup4.svg').default
        }
      }) : _vm._e(), _vm._v(" "), (word.know >= 5) ? _c('inline-svg', {
        staticClass: "progress-icon",
        attrs: {
          "src": require('../../assets/svg/progress-100.svg').default
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "audio"
      }, [_c('AudioBtn', {
        attrs: {
          "urlId": word.id
        }
      })], 1)])
    }), 0)])], 1)], 1)
  })], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": false,
      "left": false,
      "multi-line": true,
      "right": false,
      "timeout": 2000,
      "top": true,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    שומר מילה\n    "), _c('div', {
    staticClass: "snackBtns"
  }, [_c('v-btn', {
    attrs: {
      "color": "white",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n        סגירה\n      ")])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "playBtn",
    style: (_vm.safeBottomVarBtn),
    attrs: {
      "disabled": _vm.value === null
    },
    on: {
      "click": _vm.goPlay
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t("savedWords.savedWords.play")) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66c34643","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SavedWords/SavedWords.vue
// module id = 336
// module chunks = 0 6